

import { useNavigate, useParams } from "react-router-dom";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { iconos } from "../../data";
import { useCarritoXID } from "../../hooks/cache";







export const LayoutItemDeOp = ({ children, titulo }) => {


    const { id } = useParams();
    const navigate = useNavigate();
    const { data } = useCarritoXID(id);  


    return (
        <>
        <Box sx={{ mb:3 }}>
            <Grid container direction='row' alignItems='center'>
                <Box flex={1} />
                
                <Typography variant='h2' sx={{fontSize:{ xs:"1rem", sm:"1.2rem", md:"1.7rem" }, fontWeight:600}}>
                    { titulo }
                </Typography>
                
                <Box flex={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={() => navigate(-1)} sx={{ color:'#fff', backgroundColor:'secondary.main'}}>
                        {iconos['back']}
                    </IconButton>
                </Box>
            </Grid>
            
            {data && (
                <Grid container justifyContent='center'>
                    <Typography 
                        sx={{ 
                            color: 'text.secondary', 
                            fontSize: '1rem', 
                            fontWeight: 300, 
                            letterSpacing: '0.5px', 
                            opacity: 0.7,
                            mt: 0.5,
                            textAlign: 'center'
                        }}
                    >
                        {`Producto: ${data?.producto.nombre}`}
                    </Typography>
                </Grid>
            )}
        </Box>

        <Grid container alignItems='center' justifyContent='center'>
            {children}
        </Grid>
        </>
    )
}
